export enum IdentificationStatus {
    NOT_VERIFIED = "NOT_VERIFIED",
    PENDING_REVIEW = "PENDING_REVIEW",
    INFO_REQUESTED = "INFO_REQUESTED",
    VERIFIED = "VERIFIED",
    UPDATE_REQUESTED = "UPDATE_REQUESTED",
}
